import {LinearProgress} from "@mui/material";
import {FC, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useApp2Auth} from "@/app2/auth";
import {LandingPage} from "@/app2/pages/LandingPage/LandingPage";

export const LoginPage: FC = () => {
	const {authReady, authenticated} = useApp2Auth();
	const navigate = useNavigate();
	const newHomeScreen = true;
	const [isProcessingAuth, setIsProcessingAuth] = useState(false);

	useEffect(() => {
		const hasOAuthCode = window?.location?.href?.includes("?code");
		if (hasOAuthCode) {
			setIsProcessingAuth(true);
		}
	}, []);

	useEffect(() => {
		if (authenticated === true) {
			const target = newHomeScreen ? "/home" : "/training-feed";
			navigate(target, {replace: true});
		}
	}, [authenticated, navigate, newHomeScreen]);

	if (isProcessingAuth || (window?.location?.href?.includes("?code"))) {
		return <LinearProgress />;
	}

	if (!authReady) {
		return <LinearProgress />;
	}

	// After OAuth, `?code` is stripped before `authenticated` flips; avoid one frame of landing before `navigate` runs.
	if (authenticated) {
		return <LinearProgress />;
	}

	return <LandingPage />;
};
